export const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 1.65144V4.98317H14.592C13.8953 4.98317 13.4253 5.13462 13.1823 5.4375C12.9392 5.74038 12.8177 6.19471 12.8177 6.80048V9.1857H16.3785L15.9045 12.9213H12.8177V22.5H9.09896V12.9213H6V9.1857H9.09896V6.43449C9.09896 4.86959 9.52025 3.65595 10.3628 2.79357C11.2054 1.93119 12.3275 1.5 13.7292 1.5C14.9201 1.5 15.8438 1.55048 16.5 1.65144Z"
      fill="currentColor"
    />
  </svg>
);
